@if (fieldTypes$ | async; as fieldTypes) {
    @if (selectedWorkspace$ | async; as selectedWorkspace) {
        @if (hasFieldErrors$ | async; as errors) {
            <app-view-invalid-message class="w-full" [errors]="errors"></app-view-invalid-message>
        } @else if (filterHasNoResults) {
            <app-filter-no-results
                class="w-full"
                (changeFilters)="openFiltersMenu()"
            ></app-filter-no-results>
        } @else {
            <app-tb-board class="pl-4" [columnTemplate]="columnTemplate"></app-tb-board>
        }

        <ng-template #columnTemplate>
            <cdk-virtual-scroll-viewport
                class="flex h-full items-start"
                [style.width]="fullWidth()"
                orientation="horizontal"
                dynamicSize
                minBufferPx="300"
                maxBufferPx="300"
                [sizes]="columnWidths()"
                [disableAppending]="true"
            >
                <div
                    *cdkVirtualFor="
                        let group of groups;
                        let index = index;
                        trackBy: trackBy;
                        storeScrollPosition: true;
                        templateCacheSize: 5
                    "
                >
                    <app-tb-board-column
                        [items]="group.data || []"
                        [card]="card"
                        [columns]="groups || []"
                        [columnItem]="group"
                        [headerMenu]="cardHeaderMenu"
                        [disableDragIntoList]="group.value === NO_GROUPED_RECORDS_KEY"
                        [selectedItems]="selectedRecords"
                        [isCollapsedSet]="!isCollapsedNotSet(group.value, group.field?.guid)"
                        [collapsed]="getCollapseState(group.value, group.field?.guid)"
                        [columnWidths]="groupsColumHeight[index]"
                        (dropItem)="drop(group, $event)"
                        (selectColumn)="toggleGroup($event, group)"
                        (collapseChange)="setCollapseState($event, group.value, group.field?.guid)"
                    >
                        <div header class="">
                            @if (group.field && fieldTypes) {
                                <div class="flex items-center relative">
                                    <app-grouping-values
                                        [field]="group.field"
                                        [value]="group.value ?? ''"
                                    ></app-grouping-values>
                                </div>
                            } @else {
                                <span *transloco="let tBoard; read: 'board'">
                                    {{ tBoard('template') }}
                                </span>
                            }
                        </div>
                    </app-tb-board-column>

                    <ng-template
                        #cardHeaderMenu
                        let-data="data"
                        let-containerLayout="containerLayout"
                    >
                        <app-modal-layout [containerLayout]="containerLayout">
                            <ng-container
                                *transloco="let tBoardHeader; read: 'board.board_header'"
                                title
                            >
                                {{ tBoardHeader('group_title') }}
                            </ng-container>
                            @if (containerLayout === ModalContainer.BottomSheet) {
                                <ng-container subtitle>
                                    {{ group.field?.name }} / {{ groupValue(group) }}
                                </ng-container>
                            }
                            <app-board-column-header-menu
                                [data]="data"
                            ></app-board-column-header-menu>
                        </app-modal-layout>
                    </ng-template>
                </div>
            </cdk-virtual-scroll-viewport>
        </ng-template>
        <ng-template #businessCardContent let-fieldTypes="fieldTypes" let-record="record">
            @if (fields$ | async; as fields) {
                <app-board-card-fields
                    [fieldTypes]="fieldTypes"
                    [fields]="visibleFields"
                    [fieldEntities]="fields"
                    [selectedWorkspace]="selectedWorkspace"
                    [cells]="cells[record.guid]"
                    [configurationSettings]="viewData.view_configuration.configuration_settings"
                ></app-board-card-fields>
            }
        </ng-template>
        <ng-template #card let-record="item" let-group="group" let-index="index">
            <app-tb-board-card
                class="py-1 block"
                [item]="record"
                [index]="index"
                [columns]="groups || []"
                [title]="record.name.value"
                [key]="boardItemsKey"
                [moreMenu]="cardMoreMenu"
                [favorite]="favorite"
                [disableDrop]="group.value === NO_GROUPED_RECORDS_KEY"
                [selected]="isRecordSelected(record)"
                [selectedItems]="selectedRecords"
                (selectCard)="toggleSelection(record)"
                (click)="openCardDialog(record)"
            >
                <ng-container
                    *ngTemplateOutlet="
                        businessCardContent;
                        context: { fieldTypes: fieldTypes, record: record }
                    "
                ></ng-container>
                <ng-template
                    #cardMoreMenu
                    let-containerLayout="containerLayout"
                    let-close="closeFn"
                >
                    <app-modal-layout [containerLayout]="containerLayout" (closeModal)="close()">
                        <ng-container *transloco="let tBoardCard; read: 'board.board_card'" title>
                            {{ tBoardCard('card_menu_title') }}
                        </ng-container>
                        @if (containerLayout === ModalContainer.BottomSheet) {
                            <ng-container subtitle>
                                {{ record.name.value }}
                            </ng-container>
                        }
                        <app-board-card-menu [record]="record"></app-board-card-menu>
                    </app-modal-layout>
                </ng-template>
            </app-tb-board-card>
        </ng-template>
        <ng-template #favorite let-record="item">
            @if (isWatchVisible(record)) {
                <app-tb-icon-toggle-button
                    icon="custom_star_outline"
                    toggledIcon="custom_star_full"
                    class="icon-sm"
                    color="text"
                    [isActive]="watchByRecords[record.guid]"
                    (toggle)="updateWatch(record)"
                ></app-tb-icon-toggle-button>
            }
        </ng-template>
    }
}
